const styles = () => ({
  root: {
    minHeight: 100,
    padding: '40px 40px',
    height: '100vh',
    overflowY: 'auto',
  },

  header: {
    display: 'flex',
    flex: '0 0 auto',
    flexDirection: 'row',
    margin: '0 0 40px 0',
    alignItems: 'center',
  },

  title: {
    flex: '1 0 auto',
    fontSize: 30,
    color: '#414953',
    letterSpacing: '0',
    margin: 0,
    fontWeight: 500,
  },

  typography: {
    margin: '0 0 20px 0',
  },
});

export default styles;
